<template>
  <el-select
    v-if="options.values"
    v-model="searchValue"
    :placeholder="options.label"
    :size="size"
    filterable
    clearable
    style="width: 100%"
    @change="onSearch"
  >
    <el-option
      v-for="(item, index) in options.values"
      :key="index"
      :label="item[options.value_lable]"
      :value="item[options.value_value]"
    />
  </el-select>
  <el-input
    v-else
    v-model="searchValue"
    :size="size"
    :placeholder="options.label || `Поиск`"
    :title="options.label || `Поиск`"
    @change="onSearch"
    @keyup.native="onKeyup"
  />
</template>

<script>
import { updateQuery } from "@/utils/index";

export default {
  name: "Table",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    size: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      searchValue: "",
    };
  },
  created() {
    this.setSearchValueOfQuery();
  },
  methods: {
    setSearchValueOfQuery() {
      const { name } = this.options;
      const { query } = this.$route;

      if (query[name]) {
        this.searchValue = query[name];

        if (this.searchValue[0] === "%")
          this.searchValue = this.searchValue.slice(1); // удаляем первый %
        if (this.searchValue[this.searchValue.length - 1] === "%")
          this.searchValue = this.searchValue.slice(0, -1); // удаляем последний %
      }
    },
    onSearch(value) {
      const { type } = this.options;
      if (this.options.single) {
        this.$emit("searchSingle", value);
        return;
      }
      if (!value) {
        updateQuery(this, { [this.options.name]: undefined });
        return;
      }
      if (type === "list") {
        const list = value.split(",");
        updateQuery(this, { [this.options.name]: list.map((e) => e) });
        return;
      }
      const query = this.options.strong ? value : `%${value}%`;
      updateQuery(this, { [this.options.name]: query });
    },
    onKeyup(e) {
      this.$emit("quickFilter", {
        name: this.options.name,
        value: e.target.value,
        key: e.code,
      });
    },
  },
};
</script>
